<template>
    <input type="text"
           v-model="inputValue"
           :placeholder="placeholder"
           @input="valueWasChanged"
    />
</template>

<script>
    export default {
        name: "SearchInput",

        props: [
            'placeholder',
        ],

        emits: [
            'search',
        ],

        data() {
            return {
                DELAY: 0, // 700
                inputValue: '',
                startSearch: false,
                timer: null,
            }
        },

        methods: {
            valueWasChanged() {
                clearTimeout(this.timer);

                let value = this.inputValue;

                this.timer = setTimeout(() => {
                    this.search(value);
                }, this.DELAY);
            },

            search(value) {
                this.$emit('search', value);
            },

        },

    }
</script>

<style scoped>
    input {
        width: 100%;
        padding: 0;
        border: 0;
        font-size: inherit;
        font-weight: inherit;
        line-height: inherit;
        color: #000;
        background: none;
        outline: none !important;
    }

    input::placeholder {
        font-family: 'fontello', Arial, sans-serif;
        color: #555;
    }
</style>